import React, { forwardRef, Component, useState, useEffect } from "react";
import moment, { Moment } from "moment";
import { DatePicker } from "antd";
interface iProps {
  onChange?: (val) => void;
  defaultValue?: any;
  value?: any;
}
interface iState {
  isopen: boolean;
}
export default class YearPicker extends Component<iProps, iState> {
  state: iState = {
    isopen: false,
  };

  handleOpenChange = (status: boolean) => {
    this.setState({ isopen: status });
  };

  handlePanelChange = (value: any) => {
    const momentYear = moment(value, "YYYY");

    this.setState({ isopen: false });
    this.props.onChange(momentYear);
  };

  handleChanges = (date: any) => {
    this.props.onChange(moment(date));
  };
  get defaultValue() {
    let { defaultValue = null } = this.props;
    const momentYear = moment(defaultValue, "YYYY");
    return momentYear;
  }
  get value() {
    let { value = null } = this.props;
    const momentYear = moment(value, "YYYY");

    return momentYear;
  }

  render() {
    return (
      <DatePicker
        mode="year"
        placeholder="请选择年份"
        open={this.state.isopen}
        format="YYYY"
        //value={this.state.year}
        value={this.value}
        onOpenChange={this.handleOpenChange}
        onPanelChange={this.handlePanelChange}
        onChange={this.handleChanges}
        style={{ width: "100%" }}
        defaultValue={this.defaultValue}
      />
    );
  }
}
